import { render } from "./ResourcesGoal1.vue?vue&type=template&id=77e82f16"
import script from "./ResourcesGoal1.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal1.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__